import React from 'react'

const NewHomeBanner = () => {
    return (

        <div className="b4-page-home listing-page">
            <div className="canvas">
                <main className="main-wrapper">

                    <section className="header-slider-container">
                        <ul>
                            <li>
                                <div>
                                    {" "}
                                    <a
                                        href="https://www.vdc.com/"
                                        className="col-3 item smooth"

                                    >
                                        {/* <figure> */}
                                            <img
                                                style={{ height: '100px', width: '300px' }}
                                                src={'/img/svg/vdc_logo.svg'}

                                                alt="Global 4.0"
                                            />
                                        {/* </figure> */}
                                        <p className='text-center new-banner-text'>
                                            Consulting & IT Services
                                        </p>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>
                                    {" "}
                                    <a href={`/xonomy`} className="smooth">
                                        {/* <figure> */}
                                            <img
                                                style={{ height: '100px', width: '300px' }}

                                                src={`/img/svg/xonomy.svg`}
                                                alt="Industry 4.0"
                                            />
                                        {/* </figure> */}
                                        <p className='text-center new-banner-text'>
                                            Fueling the Experience Economy
                                        </p>
                                    </a>
                                </div>
                            </li>
                            <li>
                                <div>
                                    {" "}
                                    <a href={`https://www.budh.ai/`} className="smooth">
                                        {/* <figure> */}
                                            <img
                                                style={{ height: '100px', width: '260px' }}

                                                src={`/img/svg/budhai.svg`}
                                                alt="Digital 4.0"
                                            />
                                        {/* </figure> */}
                                        <p className='text-center new-banner-text'>
                                            Powering Your AI Ambition
                                        </p>
                                    </a>{" "}
                                </div>
                            </li>

                        </ul>
                    </section>
                </main>
            </div>
        </div>

    )
}

export default NewHomeBanner